import getApiLocalPort from './getApiLocalPort'

const API_DOMAIN = 'znaptech.com'
const PROD_ENVIRONMENT = 'prod'

export default function setApiRoutes(Vue, system, env) {
    const buildServiceName = (path) => {
        const pascalCaseWords = path
            .split('.')
            .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)

        return `${pascalCaseWords.join('')}Service`
    }

    const buildApiHost = () => {
        const environmentSuffix = env === PROD_ENVIRONMENT ? '' : `-${env}`

        return `https://api-${system.toLowerCase()}${environmentSuffix}.${API_DOMAIN}`
    }

    const setRoute = (path) => {
        if (env === 'local') {
            const apiLocalPort = getApiLocalPort(path)

            return `http://${window.location.hostname}:${apiLocalPort}/`
        }

        return `${buildApiHost()}/${buildServiceName(path)}/`
    }

    const setWebsocketConnection = () => {
        if (env === 'local') return { path: '/socket.io', url: setRoute('websocket') }

        return { path: `/${buildServiceName('websocket')}/socket.io`, url: buildApiHost() }
    }

    Vue.prototype.$ipUser = setRoute('user')
    Vue.prototype.$ipClient = setRoute('client')
    Vue.prototype.$ipPlPlanning = setRoute('pl.planning')
    Vue.prototype.$ipDynamicReport = setRoute('dynamic.report')
    Vue.prototype.$ipSecurity = setRoute('security')
    Vue.prototype.$ipMessage = setRoute('message')
    Vue.prototype.$ipWebsocket = setRoute('websocket')
    Vue.prototype.$websocketConnection = setWebsocketConnection()
}
